import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendarDays,
  faEllipsisVertical,
  faRectangleXmark,
} from '@fortawesome/free-solid-svg-icons';
import AppLoader from '../ui/AppLoader';
import ComparisonMaps from '../Mapping/components/Map/ComparisonMaps';
import imgNorth from '../../images/north.png';
// import Popup from '../Mapping/components/Popup/Popup';
import {
  MyLayers,
  VectorLayer,
  TileLayer,
  ImageLayer,
} from '../Mapping/components/Layers';
import { vector, wms, xyz } from '../Mapping/components/Source';
import { useSelector } from 'react-redux';
import authHeader from '../../services/auth-header';
import { get } from 'ol/proj';
import GeoJSON from 'ol/format/GeoJSON';
import DataOnDate from '../farmPage/DataOnDate';
import eviImg from '../../images/evi.jpeg';
import ndviImg from '../../images/ndvi.jpeg';
import ndmiImg from '../../images/ndmi.jpeg';
import { toast } from 'react-toastify';

const Map2Component = ({ params }) => {
  const navigate = useNavigate();
  const { rootApiUrl, isLogedIn } = useSelector((state) => state.global);
  const [center, setCenter] = useState([78.9629, 20.5937]);
  const [isEditing, setIsEditing] = useState(false);
  const [farmDataOL, setFarmDataOL] = useState(null);
  const [values, setValues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [measure, setMeasure] = useState('ndvi');
  const [selectedValue, setSelectedValue] = useState(0);
  const [showLegend, setShowLegend] = useState(false);
  const [dropDownList, setDropDownList] = useState([]);
  const [imageURL, setImageURL] = useState('');
  const [meanValue, setMeanValue] = useState(0);
  const [statsValue, setStatsValue] = useState(false);
  const [farmProperties, setFarmProperties] = useState(null);
  const [bbox, setBbox] = useState(null);
  const [statsData, setStatsData] = useState([]);

  useEffect(() => {
    if (!isLogedIn) {
      navigate('/login');
    }
  }, [isLogedIn]);

  useEffect(() => {
    if (!isLogedIn) return;
    async function getFarmData() {
      setLoading(true);

      const requestOptions = {
        method: 'GET',
        headers: authHeader(),
        redirect: 'follow',
      };

      await fetch(rootApiUrl + 'onefarm/' + params.farmId + '/', requestOptions)
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            navigate('/');
          }
        })
        .then((data) => {
          const userId = localStorage.getItem('userId');
          const Is_Superuser = localStorage.getItem('Is_Superuser');
          if (
            data.properties.user === parseInt(userId) ||
            Is_Superuser === 'true'
          ) {
            setCenter([data.properties.lon, data.properties.lat]);
            setFarmProperties(data.properties);
            setBbox(data.bbox);
            console.log('Farm data loaded:', data);
            if (!data.geometry) {
              navigate('/add-farm/' + data.id);
            } else {
              setFarmDataOL(
                new GeoJSON().readFeature(data, {
                  featureProjection: get('EPSG:4326'),
                })
              );
              // First fetch the satellite indices to check if the user has access
              getMesaureValues(data.properties);
            }
          } else {
            navigate('/403');
          }
        });

      setLoading(false);
    }

    getFarmData();
  }, [isLogedIn]);

  useEffect(() => {
    if (values && values.length > 0 && values[selectedValue] && measure) {
      const selectedItem = values[selectedValue];
      getImagery(selectedItem, measure);
    }
  }, [measure]);

  async function getMesaureValues(farmProps) {
    setLoading(true);

    const requestOptions = {
      method: 'GET',
      headers: authHeader(),
      redirect: 'follow',
    };

    await fetch(rootApiUrl + 'satellite_indices/', requestOptions)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          navigate('/');
        }
      })
      .then(async (data) => {
        const mappedIndices = data.map((item) => ({
          ...item,
          name: item.name.toUpperCase(),
        }));

        setDropDownList(mappedIndices);

        if (mappedIndices.length > 0) {
          const defaultMeasure =
            mappedIndices[0].name.toLowerCase();

          setMeasure(defaultMeasure);

          await getDateValues(
            defaultMeasure,
            true,
            farmProps,
            mappedIndices
          );
          setStatsValue(true);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error('Error occur please check logs');
      });

    setLoading(false);
  }

  function changeMeasureOpt(event) {
    setMeasure(event.target.value);
    setStatsValue(true);
  }

  function changeDates(item, index) {
    setSelectedValue(index);
    getImagery(item, measure);
  }



  async function getDateValues(opt, statBoolen, farmProps, indicesList) {
    setLoading(true);

    const propsToUse = farmProps || farmProperties;
    const geometryId = propsToUse?.observearth_id;
    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);
    const startDateVal = thirtyDaysAgo.toISOString().split('T')[0];
    const endDateVal = today.toISOString().split('T')[0];

    console.log('observearth_id:', geometryId);
    console.log('calculated start_date:', startDateVal);

    if (!geometryId) {
      console.warn("Observeearth ID is missing");
      setLoading(false);
      return;
    }

    const domain = process.env.REACT_APP_OBSERVEARTH_DOMAIN || 'https://khetibuddy.observearth.com';
    const observearthApiKey =
      (propsToUse?.observearth_api_key && propsToUse.observearth_api_key.trim() !== '') ? propsToUse.observearth_api_key :
      (localStorage.getItem("observearth_api_key") && localStorage.getItem("observearth_api_key").trim() !== '') ? localStorage.getItem("observearth_api_key") :
      (localStorage.getItem("observeearth_api_key") && localStorage.getItem("observeearth_api_key").trim() !== '') ? localStorage.getItem("observeearth_api_key") :
      (process.env.REACT_APP_OBSERVEARTH_API_KEY && process.env.REACT_APP_OBSERVEARTH_API_KEY.trim() !== '') ? process.env.REACT_APP_OBSERVEARTH_API_KEY :
      null;

    if (!observearthApiKey) {
      toast.error('Observearth API key is not configured for this farm.');
      setLoading(false);
      return;
    }

    const payload = {
      geometry_id: geometryId,
      start_date: startDateVal,
      end_date: endDateVal,
      cloud_cover: 100,
    };

    console.log('Observeearth request payload:', payload);

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 300000);

    const requestOptions = {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json',
        'x-api-key': observearthApiKey,
      },
      body: JSON.stringify(payload),
      signal: controller.signal,
    };

    try {
      const response = await fetch(`${domain}/api/s2/search/`, requestOptions);
      if (!response.ok) {
        throw new Error(`Observeearth API error: ${response.statusText}`);
      }
      const data = await response.json();
      console.log('Observeearth response:', data);
      const results = data.results || [];
      const mappedData = results.map((item) => ({
        id: item.id,
        date: item.date,
        value: item.cloud_cover,
        cloud_cover: item.cloud_cover,
        platform: item.platform,
      }));

      if (mappedData.length > 0) {
        setValues(mappedData);
        let excludeDates = [];
        mappedData.forEach((x) => {
          if (x.value === null) excludeDates.push(Date.parse(x.date));
        });
        const firstItem = mappedData[0];
        setSelectedValue(0);

        getImagery(firstItem, opt, propsToUse, indicesList);
      } else {
        setValues([]);
      }
    } catch (err) {
      console.log(err);
      toast.error('Error fetching dates from Observearth API');
    } finally {
      clearTimeout(timeoutId);
    }
    setLoading(false);
  }

  async function getImagery(selectedItem, measure, farmProps, indicesList) {
    setLoading(true);
    setImageURL('');
    setMeanValue(0);

    const propsToUse = farmProps || farmProperties;
    const geometryId = propsToUse?.observearth_id;

    let itemId = selectedItem?.id;
    let selectedDateVal = selectedItem?.date;
    if (typeof selectedItem === 'string') {
      selectedDateVal = selectedItem;
      const foundItem = values.find((v) => v.date === selectedItem);
      if (foundItem) {
        itemId = foundItem.id;
      }
    }

    console.log("Selected Item:", selectedItem);
    console.log("Observeearth ID:", geometryId);
    console.log("Index:", measure);

    if (!geometryId || !itemId) {
      setLoading(false);
      return;
    }

    const domain = process.env.REACT_APP_OBSERVEARTH_DOMAIN || 'https://khetibuddy.observearth.com';
    const observearthApiKey =
      (propsToUse?.observearth_api_key && propsToUse.observearth_api_key.trim() !== '') ? propsToUse.observearth_api_key :
      (localStorage.getItem("observearth_api_key") && localStorage.getItem("observearth_api_key").trim() !== '') ? localStorage.getItem("observearth_api_key") :
      (localStorage.getItem("observeearth_api_key") && localStorage.getItem("observeearth_api_key").trim() !== '') ? localStorage.getItem("observeearth_api_key") :
      (process.env.REACT_APP_OBSERVEARTH_API_KEY && process.env.REACT_APP_OBSERVEARTH_API_KEY.trim() !== '') ? process.env.REACT_APP_OBSERVEARTH_API_KEY :
      null;

    if (!observearthApiKey) {
      toast.error('Observearth API key is not configured for this farm.');
      setLoading(false);
      return;
    }

    const currentIndicesList = indicesList || dropDownList || [];
    const selectedIndex = currentIndicesList.find(
      (item) => item.name.toLowerCase() === measure.toLowerCase()
    );
    const minVal = selectedIndex ? (selectedIndex.min_value !== undefined && selectedIndex.min_value !== null ? selectedIndex.min_value : selectedIndex.min_val) : null;
    const maxVal = selectedIndex ? (selectedIndex.max_value !== undefined && selectedIndex.max_value !== null ? selectedIndex.max_value : selectedIndex.max_val) : null;

    let url = `${domain}/api/s2/image/${geometryId}/?item_id=${itemId}&image_type=png&index=${measure}&pixelized=false`;
    if (minVal !== null && minVal !== undefined && minVal !== 'null') {
      url += `&min_val=${minVal}`;
    }
    if (maxVal !== null && maxVal !== undefined && maxVal !== 'null') {
      url += `&max_val=${maxVal}`;
    }

    console.log("Image Request URL:", url);

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 300000);

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "application/json",
          "x-api-key": observearthApiKey,
        },
        signal: controller.signal,
      });

      if (!response.ok) {
        throw new Error(`Observeearth imagery API error: ${response.statusText}`);
      }

      const responseText = await response.text();
      console.log("Image Response:", responseText);

      const base64Data = responseText.trim();
      let imageUrl = '';
      if (base64Data.startsWith('{')) {
        try {
          const parsed = JSON.parse(base64Data);
          const val = parsed.url || parsed.image_url || parsed.image || parsed.data || parsed.base64;
          if (val) {
            imageUrl = val.startsWith('data:') ? val : `data:image/png;base64,${val}`;
          }
        } catch (e) {}
      }

      if (!imageUrl) {
        imageUrl = base64Data.startsWith('data:') ? base64Data : `data:image/png;base64,${base64Data}`;
      }

      setImageURL(imageUrl);

      try {
        const statsResponse = await fetch(`${domain}/api/s2/stats/${geometryId}/?item_id=${itemId}&index=${measure}`, {
          method: "GET",
          headers: {
            "accept": "application/json",
            "x-api-key": observearthApiKey,
          }
        });
        if (statsResponse.ok) {
          const statsData = await statsResponse.json();
          if (statsData && statsData.mean !== undefined && statsData.mean !== null) {
            setMeanValue(parseFloat(statsData.mean).toFixed(3));
          } else {
            setMeanValue(0);
          }
        } else {
          setMeanValue(0);
        }
      } catch (statsErr) {
        console.error("Observeearth stats fetch error:", statsErr);
        setMeanValue(0);
      }
    } catch (err) {
      console.log(err);
      toast.error('Error fetching imagery from Observearth API');
    } finally {
      clearTimeout(timeoutId);
    }
    setLoading(false);
  }



  // let layerName =
  //   values.length > 0 &&
  //   'kb:' + measure + '-' + values[selectedValue]?.date + '-' + params.farmId;

  return (
    <>
      <AppLoader show={loading} />
      <div className='flex flex-col w-full lg:w-1/2 lg:border-l-2 lg:border-lime-700 bg-ext-dark text-ext-green-light'>
        <div className='relative h-[50vh] lg:h-auto lg:basis-3/4 text-ext-dark'>
          {dropDownList.length > 0 && (
            <span className='absolute z-10 p-2 bg-white rounded-lg shadow-lg bottom-4 left-4'>
              {!showLegend && (
                <span
                  className='text-xs font-bold cursor-pointer text-ext-darker'
                  onClick={() => {
                    setShowLegend(!showLegend);
                  }}>
                  <FontAwesomeIcon icon={faEllipsisVertical} className='mr-2' />{' '}
                  Show Legend
                </span>
              )}
              {showLegend && (
                <FontAwesomeIcon
                  icon={faRectangleXmark}
                  className='absolute z-10 block text-2xl text-red-500 cursor-pointer -right-1 -top-1'
                  onClick={() => {
                    setShowLegend(!showLegend);
                  }}
                />
              )}
              {measure === 'ndvi' && showLegend && (
                <img src={ndviImg} alt='legend' className='h-[35vh]' />
              )}
              {measure === 'ndmi' && showLegend && (
                <img src={ndmiImg} alt='legend' className='h-[35vh]' />
              )}
              {measure === 'evi' && showLegend && (
                <img src={eviImg} alt='legend' className='h-[35vh]' />
              )}
            </span>
          )}
          <ComparisonMaps
            center={center}
            zoom={5}
            trackLocation={false}
            isMap2={true}>
            <img
              src={imgNorth}
              alt='north'
              className='absolute z-10 object-contain p-1 rounded-md w-9 h-9 bg-ext-green-light bg-opacity-60 right-2 top-2'
            />
            {/* <Popup
              type='wms'
              edit={isEditing}
              isComparison={true}
              isMap2={true}
            /> */}
            <MyLayers>
              <TileLayer
                source={xyz(
                  'http://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}'
                )}
                isMap2={true}
                isComparison={true}
                zIndex={0}
              />
              {/* {values.length > 0 && (
                <TileLayer
                  name='farmWms'
                  source={wms({
                    url: 'https://gis.khetibuddy.com/geoserver/kb/wms',
                    layer: layerName,
                  })}
                  isMap2={true}
                  isComparison={true}
                  zIndex={2}
                />
              )} */}
              {farmDataOL && (
                <VectorLayer
                name='farmLayer'
                  zIndex={2}
                  isMap2={true}
                  isComparison={true}
                  source={vector({
                    features: [farmDataOL],
                  })}
                />
              )}
              {imageURL && (
                <ImageLayer zIndex={1}
                  urlPath={imageURL}
                  isComparison={true}
                  isMap2={true}
                  extent={bbox} />
              )}
            </MyLayers>
          </ComparisonMaps>
        </div>
        <div className='min-h-fit lg:h-auto lg:basis-1/4 p-2 bg-ext-dark'>
          <div className='flex justify-between '>
          <select
              className='text-2xl bg-transparent font-extralight cursor-pointer'
              value={measure}
              onChange={changeMeasureOpt}>
              {' '}
              {dropDownList.map((e, key) => {
                return (
                  <option
                    key={key}
                    value={e.name.toLowerCase()}
                    className='bg-black'>
                    {e.name.toUpperCase()}
                  </option>
                );
              })}
            </select>
            {(() => {
              if (statsValue) {
                return <div className='opacity-50'>{meanValue}</div>;
              }

              return null;
            })()}
          </div>
          <div className='flex items-center mt-3'>
            <div className='mr-3 text-center'>
              <FontAwesomeIcon icon={faCalendarDays} className='text-2xl' />
              <br></br>
              Date
            </div>
            <div className=' overflow-y-auto pb-1'>
              <div className='flex w-max'>
                {values?.map((item, index) =>
                  item.value !== null && item.value !== undefined ? (
                    <button
                      key={item.id}
                      className={
                        selectedValue === index
                          ? 'bg-ext-green bg-opacity-30 rounded-md'
                          : ''
                      }
                      type='submit'
                      onClick={() => {
                        changeDates(item, index);
                      }}>
                      <DataOnDate
                        date={item.date}
                        // cloud="100%"
                        // image="100%"
                        sat={item.value}
                      />
                    </button>
                  ) : (
                    <ul
                      key={index}
                      className='p-3 text-left border-r rounded-lg border-ext-darker'>
                      <li className='mb-2'>
                        <FontAwesomeIcon
                          icon={faCalendarDays}
                          className='w-6 mr-2 text-lg text-ext-green'
                        />{' '}
                        {item.date}
                      </li>
                      <li className='opacity-50'>Data not available</li>
                    </ul>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Map2Component;
